import { z } from 'zod';
import { DocumentCornSchema, ImageCornSchema, InspectionCornSchema } from '../base.js';
import { DocumentSchema } from '../entities/document.js';
import { UploadedFloorplanSchema } from '../entities/floorplans.js';
import { ImageSchema } from '../entities/image.js';
import { VideoSchema } from '../entities/video.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
export const ImageReceivedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('image', 'received'),
    image: ImageSchema,
}));
export const VideoReceivedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('video', 'received'),
    video: VideoSchema,
}));
export const DocumentReceivedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('document', 'received'),
    document: DocumentSchema,
}));
export const FloorplanReceivedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('floorplan', 'received'),
    floorplan: UploadedFloorplanSchema,
}));
export const ImageUpdatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('image', 'updated'),
    image: ImageSchema,
}));
export const VideoUpdatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('video', 'updated'),
    video: VideoSchema,
}));
export const DocumentUpdatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('document', 'updated'),
    document: DocumentSchema,
}));
export const ImageDeletedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('image', 'deleted'),
    image: z.object({
        imageId: ImageCornSchema,
        inspectionId: InspectionCornSchema,
    }),
}));
export const DocumentDeletedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('document', 'deleted'),
    document: z.object({
        documentId: DocumentCornSchema,
        inspectionId: InspectionCornSchema,
    }),
}));
